





















import { Component, Prop, Vue } from 'vue-property-decorator';

@Component({
    props: ['header', 'subheader'],
})
export default class LoginRequiredPanel extends Vue {

    get panelHeader(): string {
        return this.$props.header;
    }

    get panelSubheader(): string {
        return this.$props.subheader;
    }

    get config() {
        return this.$store.state.config;
    }

    public onLogin() {
        return this.$store.dispatch('login');
    }

    public onRegister() {
        return this.$store.dispatch('login');
    }

}
